require('angular-sanitize');
require('core-js-error');
require('utility-ng-interface');
require('utility-ng-enumeration');
require('ui-ng-delegate');
require('./core');
require('./core/notification_delegate');

// module.exports = 'ui-ng-notification';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-notification/src/main.js